import { useState } from 'react';

interface ModalState {
    Component: any;
    isOpen: boolean;
}

export default function useModal() {
    const [modal, setModal] = useState<ModalState>({
        isOpen: false,
        Component: null,
    });

    const toggleModal = (Component: any, data: object = {}) =>
        setModal((prevState: { isOpen: boolean }) => ({
            isOpen: !prevState.isOpen,
            Component: prevState.isOpen ? null : <Component data={data} close={toggleModal} />,
        }));

    return { open: toggleModal, modal };
}
